export function renderStructuredText(container: HTMLElement, text: string): void {
  container.replaceChildren();
  const lines = text.replaceAll("\r\n", "\n").split("\n");
  let paragraph: string[] = [];
  let list: HTMLUListElement | null = null;

  const flushParagraph = (): void => {
    if (!paragraph.length) return;
    const element = document.createElement("p");
    element.textContent = paragraph.join("\n");
    container.append(element);
    paragraph = [];
  };
  const closeList = (): void => { list = null; };

  for (const line of lines) {
    const heading = /^(#{1,3})\s+(.+)$/.exec(line);
    const bullet = /^[-*]\s+(.+)$/.exec(line);
    if (heading) {
      flushParagraph(); closeList();
      const element = document.createElement("h3");
      element.textContent = heading[2] ?? "";
      container.append(element);
    } else if (bullet) {
      flushParagraph();
      if (!list) {
        list = document.createElement("ul");
        container.append(list);
      }
      const item = document.createElement("li");
      item.textContent = bullet[1] ?? "";
      list.append(item);
    } else if (!line.trim()) {
      flushParagraph(); closeList();
    } else {
      closeList(); paragraph.push(line);
    }
  }
  flushParagraph();
  if (!container.childNodes.length) container.textContent = "No answer returned.";
}

